import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Space, Upload } from "antd"
import { UploadOutlined, DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { apiPrefix } from "../../../js/config"
import _ from 'lodash'

interface leftAmount {
    agreement_amount: number // 合同总金额，小数类型
    total_agreement_pay_amount: number // 合同已收金额，小数类型
    total_agreement_left_amount: number // 合同待收金额，小数类型
}

interface reciveRow {
    refund_date: undefined | string, // 退款日期，例如“2021-06-30”
    refund_amount: undefined | string, // 退款金额，小数类型
    refund_prov_pic_list: undefined | string[], // 退款收据图片集合，上传图片接口返回的图片路径
    refund_reason: undefined | string // 退款原因
}

interface Prop {
    storeID?: string
}

const upLoadProps = {
    name: 'files',
    data: { fileType: 1, bucketType: 4 },
    action: apiPrefix + '/global/upload_pic',
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [data, setData] = useState<leftAmount>()
    const [visible, setVisible] = useState<boolean>(false)

    let reciveMoneyRow: reciveRow = {
        refund_date: undefined,
        refund_amount: undefined,
        refund_prov_pic_list: [],
        refund_reason: undefined
    }

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([{
        refund_date: undefined,
        refund_amount: undefined,
        refund_prov_pic_list: [],
        refund_reason: undefined
    }])

    const addMoreRow = () => {
        setReciveMoneyData([...reciveMoneyData, reciveMoneyRow])
    }

    const deleteRow = (index: number) => {
        if (reciveMoneyData.length > 1) {
            let reciveD = _.cloneDeep(reciveMoneyData)
            reciveD.splice(index, 1)

            setReciveMoneyData(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)
        reciveD[index][attr] = value

        setReciveMoneyData(reciveD)
    }

    const uploadChange = (info: any, index: number) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)

        if (info.file.status === 'done') {
            message.success(`${info.file.name} 上传成功`)
            reciveD[index].refund_prov_pic_list.push(info.file.response.data[0])

            setReciveMoneyData(reciveD)

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);

        } else if (info.file.status === 'removed') {
            let i = reciveD[index].refund_prov_pic_list.findIndex((el: string) => el === info.file.response.data[0])
            reciveD[index].refund_prov_pic_list.splice(i, 1)

            setReciveMoneyData(reciveD)
        }
    }

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/left_amount/info', {
            params: {
                check_in_id: param.id,
                type: 0
            }

        }).then((res: any) => {
            res && setData(res)
        })

    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/refund_amount/add', {
            check_in_id: param.id,
            refund_detail: reciveMoneyData

        }).then(res => {
            if (res.status === 0) {
                message.success(`录入成功`)
                setVisible(false)
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 录入退款 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>录入退款</Button>

        <Modal title="录入退款" width={850} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Space>
                <p>合同总金额：{data?.agreement_amount}元</p>
                <p>合同已收金额：{data?.total_agreement_pay_amount}元</p>
                <p>合同待收金额：{data?.total_agreement_left_amount}元</p>
            </Space>

            <Row style={{ marginBottom: 16 }} gutter={8} justify="space-around">
                <Col span={5}>退款日期<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>退款金额<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>退款凭证<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>退款原因</Col>
                <Col span={1}></Col>
            </Row>

            {reciveMoneyData.map((el, index: number) =>
                <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                    <Col span={5}>
                        <DatePicker onChange={(v: any) => {
                            handleChange(index, 'refund_date', v.format('YYYY-MM-DD'))
                        }} />
                    </Col>
                    <Col span={3}>
                        <Input value={el.refund_amount} onChange={(e) => {
                            handleChange(index, 'refund_amount', e.target.value)
                        }} />
                    </Col>
                    <Col span={3} style={{ paddingTop: 4 }}>
                        <Space>
                            <Upload {...upLoadProps} onChange={(info: any) => {
                                uploadChange(info, index)
                            }}>
                                <Button icon={<UploadOutlined />} size="small" ></Button>
                            </Upload>
                        </Space>
                    </Col>
                    <Col span={3}>
                        <Input value={el.refund_reason} onChange={(v) => {
                            handleChange(index, 'refund_reason', v.target.value)
                        }} />
                    </Col>
                    <Col span={1} style={{ paddingTop: 4 }}>
                        <DeleteOutlined onClick={() => {
                            deleteRow(index)
                        }} style={{ cursor: 'pointer' }} />
                    </Col>
                </Row>
            )}

            <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加退款</Button>
        </Modal>
    </Fragment>
}